import React, { useState } from "react";
import axios from "../../../../axios";
import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Stack,
  CircularProgress,
} from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";

const ConfirmSubmitStudent = ({ setClickedSubmit, assessmentId }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleSubmitAssessment = async () => {
    setLoading(true);
    try {
      let res = await axios.put(
        `/api/v1/assessment/updateStatus/${assessmentId}`,
        {
          status: "completed",
        },
      );
      if (res) navigate("/PublishedAssessment");
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => setClickedSubmit((prev) => !prev);

  return (
    <Dialog
      open
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 0,
          boxShadow: "0 24px 60px rgba(0,0,0,0.25)",
          overflow: "hidden",
        },
      }}
    >
      <DialogContent sx={{ p: "28px 24px 16px" }}>
        {/* Warning icon */}
        <Box
          sx={{
            width: 60,
            height: 60,
            borderRadius: "50%",
            bgcolor: "#FFF7ED",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mx: "auto",
            mb: 2,
          }}
        >
          <WarningAmberRoundedIcon sx={{ fontSize: 30, color: "#F97316" }} />
        </Box>

        {/* Title */}
        <Typography
          sx={{
            fontSize: 17,
            fontWeight: 700,
            color: "#111827",
            textAlign: "center",
            lineHeight: 1.3,
            mb: 1,
          }}
        >
          Publish Results?
        </Typography>

        {/* Message */}
        <Typography
          sx={{
            fontSize: 13,
            color: "#6B7280",
            textAlign: "center",
            lineHeight: 1.55,
          }}
        >
          Some students haven't submitted the assessment yet. Do you still want
          to publish the result?
        </Typography>
      </DialogContent>

      <DialogActions
        sx={{
          px: 3,
          pb: 3,
          pt: 1,
          gap: 1.5,
          justifyContent: "center",
        }}
      >
        <Button
          onClick={handleClose}
          variant="outlined"
          disabled={loading}
          sx={{
            flex: 1,
            textTransform: "none",
            fontWeight: 600,
            fontSize: 13,
            borderRadius: 2,
            py: 1,
            borderColor: "#E5E7EB",
            color: "#374151",
            "&:hover": {
              borderColor: "#D1D5DB",
              bgcolor: "#F9FAFB",
            },
          }}
        >
          Go Back
        </Button>

        <Button
          onClick={handleSubmitAssessment}
          variant="contained"
          disabled={loading}
          startIcon={
            loading ? (
              <CircularProgress size={14} sx={{ color: "#fff" }} />
            ) : null
          }
          sx={{
            flex: 1,
            textTransform: "none",
            fontWeight: 600,
            fontSize: 13,
            borderRadius: 2,
            py: 1,
            bgcolor: "#F97316",
            boxShadow: "0 3px 10px rgba(249,115,22,.25)",
            "&:hover": {
              bgcolor: "#EA580C",
              boxShadow: "0 5px 14px rgba(249,115,22,.35)",
            },
            "&.Mui-disabled": {
              bgcolor: "#FED7AA",
              color: "#fff",
            },
          }}
        >
          {loading ? "Publishing..." : "Continue"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmSubmitStudent;
